export default __webpack_public_path__ + "images/c310026a5af17bc01efc7ec28d98faf0-fallevents_small.webp";